import {
  apiGet,
  apiPost,
  apiDownloadPost,
} from '../../api/index';
import { urlProfessors } from '../../api/urls';

export function getSubjects(showAll, params) {
  return apiPost(`${urlProfessors}/subjects/${showAll}`, params.pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function getAllSubjectsDashboard(params) {
  return apiGet(`${urlProfessors}/all_subjects_dashboard`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function addToFavorites(inscripcion, callback) {
  return apiPost(`${urlProfessors}/add_subject_dashboard`, inscripcion)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch(async (error) => {
      if (callback && callback.onError) callback.onError(await error.json());
    });
}

export function reporteRegistroContenidoProfesores({
  pageInfo = ({ page: 1, pageSize: 15 }),
  onSuccess,
  onError,
}) {
  return apiPost(`${urlProfessors}/report-content-record`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function descargarReporteRegistroContenidoProfesores({ filters = {}, onSuccess, onError }) {
  return apiDownloadPost(`${urlProfessors}/report-content-record-download`, filters)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Reporte de registro de contenido de profesores.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();

      if (onSuccess) onSuccess(blob);
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
